module.exports = __webpack_public_path__ + "static/media/11.fc88c30b.png";